import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { Gallery } from "../components/Gallery";
import { Reveal } from "../components/Reveal";

export default function GalleryPage() {
  const { t } = useLanguage();
  return (
    <main data-testid="gallery-page">
      <SEOHead title={t.meta.gallery.title} description={t.meta.gallery.description} />
      <PageHeader eyebrow={t.galleryPage.eyebrow} title={t.galleryPage.title} text={t.galleryPage.text} crumb={t.nav.gallery} testId="gallery-header" />
      <section className="container-x pb-24 md:pb-32">
        <Reveal><Gallery /></Reveal>
      </section>
    </main>
  );
}
